<template >
  <div
    class="avantage-desktop-box"
    :class="modulo_index == 1 ? 'avantage-box-left' : ''"
  >
    <slot name="image" />
    <div class="avantage-box-text-container">
      <div class="avantage-box-text">
        <slot name="name" />
        <slot name="title" />
        <slot name="description" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modulo_index: "",
    };
  },
  mounted() {
    let index_key = this.$vnode.key;
    this.modulo_index = index_key % 2;
  },
};
</script>
